"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Toast notification service
 */

(function ($) {
  /** Типы нотификаций*/
  var ToastsTypes = {
    /**  */
    "default": 'default',
    /** */
    primary: 'primary',
    /** */
    success: 'success',
    /** */
    info: 'info',
    /** */
    warning: 'warning',
    /** */
    danger: 'danger'
  };
  'use strict';
  $.b2b = $.b2b || {}; // check namespace

  var defaultOptions = {
    timeout: 3000,
    type: ToastsTypes.success,
    click: null
  };
  var getIcon = function getIcon(type) {
    switch (type) {
      case ToastsTypes.success:
        return 'fa-check';
        break;
      case ToastsTypes.danger:
        return 'fa-exclamation toast__icon__danger';
        break;
      case ToastsTypes["default"]:
      case ToastsTypes.info:
      case ToastsTypes.warning:
      default:
        return 'fa-exclamation toast__icon__danger';
        break;
    }
  };

  /** UI сервис нотификаций б2б */
  // ReSharper disable once InconsistentNaming
  var ToastNotificationService = function ToastNotificationService() {
    var _this = this;
    var me = {
      $el: null
    };

    /**
     * Показывает нотификацию с указанным сообщением об успешном окончании операции
     * @param {any} message
     */
    this.showSuccess = function (message, options) {
      return _this.show(message, {
        type: ToastsTypes.success
      });
    };
    /**
     * Показывает нотификацию с указанным сообщением об ошибке
     * @param {any} message
     */
    this.showError = function (message, options) {
      return _this.show(message, _objectSpread(_objectSpread({}, options), {}, {
        type: ToastsTypes.danger
      }));
    };
    /**
     * Показывает нотификацию с указанным сообщением с предупреждением
     * @param {any} message
     */
    this.showWarning = function (message, options) {
      return _this.show(message, _objectSpread(_objectSpread({}, options), {}, {
        type: ToastsTypes.warning
      }));
    };
    /**
     * Показывает нотификацию с указанным сообщением информирую пользователя
     * @param {any} message
     */
    this.showInfo = function (message, options) {
      return _this.show(message, _objectSpread(_objectSpread({}, options), {}, {
        type: ToastsTypes.info
      }));
    };
    this.show = function (message, options) {
      options = options || {};
      var opt = $.extend({}, defaultOptions, options);

      // берем текущий контейнер или добавляем новый
      if (me.$el == null) {
        me.$el = $('<div class="toasts-container"></div>');
        $(document.body).append(me.$el);
      }

      // формируем сообщение
      var messageEl = $('<div class="toast toast-' + opt.type + '"><div class="toast__icon"><span class="fa ' + getIcon(opt.type) + '"></span></div><button type="button" class="close" aria-label="close"><span aria-hidden="true">×</span></button><div class="toast__body">' + message + '</div></div>');
      messageEl.hide();
      me.$el.prepend(messageEl); // добавляем последний наверх

      // общая функция скрытия сообщения
      var hideToast = function hideToast(el) {
        var toastWidth = el.width();
        el.animate({
          left: '+=' + (toastWidth + 20)
        }, 'linear', function () {
          el.animate({
            height: '-=0'
          }, 'easeOutQuart', function () {
            el.remove();
          });
        });
      };
      var timeoutHandler = {
        id: null
      };
      messageEl.find('.close').click(function (e) {
        e.preventDefault();
        e.stopPropagation(); // stop bubbling to parent
        // если была установлена задержка, то отписываемся от нее
        if (timeoutHandler.id) {
          clearTimeout(timeoutHandler.id);
        }
        hideToast(messageEl);
      });
      if (typeof opt.click === 'function') {
        messageEl.addClass('interactive');
        messageEl.on('click', function (e) {
          opt.click.call(window, {
            hide: function hide() {
              if (timeoutHandler.id) {
                clearTimeout(timeoutHandler.id);
              }
              hideToast(messageEl);
            }
          });
        });
      }
      var def = $.Deferred();

      // показываем toast и затем сверху вниз его
      var toastHeight = messageEl.height();
      messageEl.css('top', 0 - toastHeight);
      messageEl.show();
      messageEl.animate({
        top: '+=' + toastHeight
      }, 'easeOutQuart', function () {
        if (opt.timeout <= 0) {
          def.resolve();
          return def;
        }

        // через N мс сдвигаем вправо и уменьшаем высоту до 0, затем удаляем. css3 transition не используем.
        timeoutHandler.id = setTimeout(function () {
          hideToast(messageEl);
          def.resolve();
        }, opt.timeout);
      });
      return def;
    };
  };

  /** Сервис нотификаций */
  $.b2b.toastNotificationService = new ToastNotificationService();
})(jQuery);